import Marquee from "react-fast-marquee";

const ITEMS = ["ROI-Focused", "Data-Driven", "Creative Strategies", "Transparent Reporting", "Certified Experts", "Proven Results"];

export default function EditorialMarquee() {
  return (
    <div className="py-6 bg-[#0F172A] overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-head font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white/90 px-8">{t}</span>
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: "#F97316" }} />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
